import { render } from "./ShoppingItem.vue?vue&type=template&id=45682d66&scoped=true"
import script from "./ShoppingItem.vue?vue&type=script&lang=js"
export * from "./ShoppingItem.vue?vue&type=script&lang=js"

import "./ShoppingItem.vue?vue&type=style&index=0&id=45682d66&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45682d66"]])

export default __exports__